import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sponsored_sales_card = _resolveComponent("sponsored-sales-card");
  const _component_spend_card = _resolveComponent("spend-card");
  const _component_tacos_card = _resolveComponent("tacos-card");
  const _component_cvr_card = _resolveComponent("cvr-card");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createBlock(_component_flex_row, {
    gap: 24,
    styles: {
      alignSelf: 'stretch'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_sponsored_sales_card, {
      loading: $props.loading,
      amount: _ctx.kpis[_ctx.periodCategory]?.[0]?.amount,
      subtitleAmount: _ctx.kpis[_ctx.periodCategory]?.[0]?.subtitleAmount,
      percentage: _ctx.kpis[_ctx.periodCategory]?.[0]?.percentage,
      subtitlePercentage: _ctx.kpis[_ctx.periodCategory]?.[0]?.subtitlePercentage
    }, null, 8, ["loading", "amount", "subtitleAmount", "percentage", "subtitlePercentage"]), _createVNode(_component_spend_card, {
      loading: $props.loading,
      amount: _ctx.kpis[_ctx.periodCategory]?.[1]?.amount,
      percentage: _ctx.kpis[_ctx.periodCategory]?.[1]?.percentage,
      subtitleAmount: _ctx.kpis[_ctx.periodCategory]?.[1]?.subtitleAmount,
      subtitlePercentage: _ctx.kpis[_ctx.periodCategory]?.[1]?.subtitlePercentage
    }, null, 8, ["loading", "amount", "percentage", "subtitleAmount", "subtitlePercentage"]), _createVNode(_component_tacos_card, {
      loading: $props.loading,
      amount: _ctx.kpis[_ctx.periodCategory]?.[2]?.amount,
      percentage: _ctx.kpis[_ctx.periodCategory]?.[2]?.percentage,
      percentageColor: _ctx.kpis[_ctx.periodCategory]?.[2]?.percentageColor,
      percentageBgColor: _ctx.kpis[_ctx.periodCategory]?.[2]?.percentageBgColor,
      subtitleAmount: _ctx.kpis[_ctx.periodCategory]?.[2]?.subtitleAmount,
      subtitlePercentage: _ctx.kpis[_ctx.periodCategory]?.[2]?.subtitlePercentage
    }, null, 8, ["loading", "amount", "percentage", "percentageColor", "percentageBgColor", "subtitleAmount", "subtitlePercentage"]), _createVNode(_component_cvr_card, {
      loading: $props.loading,
      amount: _ctx.kpis[_ctx.periodCategory]?.[3]?.amount,
      percentage: _ctx.kpis[_ctx.periodCategory]?.[3]?.percentage,
      percentageColor: _ctx.kpis[_ctx.periodCategory]?.[3]?.percentageColor,
      percentageBgColor: _ctx.kpis[_ctx.periodCategory]?.[3]?.percentageBgColor,
      subtitleAmount: _ctx.kpis[_ctx.periodCategory]?.[3]?.subtitleAmount,
      subtitlePercentage: _ctx.kpis[_ctx.periodCategory]?.[3]?.subtitlePercentage
    }, null, 8, ["loading", "amount", "percentage", "percentageColor", "percentageBgColor", "subtitleAmount", "subtitlePercentage"])]),
    _: 1
  });
}